/* eslint-disable hum/require-constants-import */

export const uploadColorMap: Record<string, string> = {
    balance_sheet: "#08BDBA",
    income_statement: "#4A66F4",
    financial_summary: "#DFBF03",
    company_deck: "#60A5FA",
    cap_table: "#B215DA",
    transaction_data: "#28A138",
    mixed: "#9CA3AF",
    other: "#F8FAFC",
    unknown: "#9CA3AF",
};
